import React from 'react'
// Components
import PageTransition from '../components/PageTransition'
// CSS
import '../assets/css/help.css'

export default function Help() {
  return (
    <div className='help_page'>
      <PageTransition />
      <div className="container">
        <header>
          <div className="title">Help and Support</div>
          <form>
            <input type="text" placeholder="Ask a question" required />
            <button>Ask</button>
          </form>
        </header>
        <div className="questions">
          <div className="header"><div className="title">Questions</div></div>
          <nav className="category-nav">
            <div className="title">Filter Questions</div>
            <div className="categories-container">
              <button className="active"><span className="fas fa-braille" aria-hidden="true" /> All</button>
              <button><span className="fas fa-truck-loading" aria-hidden="true" /> Order</button>
              <button><span className="fas fa-th" aria-hidden="true" /> Product</button>
              <button><span className="fas fa-user" aria-hidden="true" /> Account</button>
              <button><span className="fas fa-truck" aria-hidden="true" /> Delivery</button>
              <button><span className="fas fa-money-bill" aria-hidden="true" /> Payment</button>
            </div>
          </nav>
          <div className="questions-container">
            <div className="question-card">
              <div className="question">
                <div className="profile-info">
                  <div className="image"><img src="https://via.placeholder.com/150" /></div>
                  <div className="name">Forhad Hossain</div>
                </div>
                <p>How to order something?</p>
              </div>
              <div className="reply">
                <div className="profile-info">
                  <div className="image"><img src="https://via.placeholder.com/150" /></div>
                  <div className="name">Sreca</div>
                </div>
                <p>Click on the add to cart button then checkout the product with additional information then select payment method and continue to the payment process for order.</p>
              </div>
            </div>
            <div className="question-card">
              <div className="question">
                <div className="profile-info">
                  <div className="image"><img src="https://via.placeholder.com/150" /></div>
                  <div className="name">Forhad Hossain</div>
                </div>
                <p>How to order something?</p>
              </div>
              <div className="reply">
                <div className="profile-info">
                  <div className="image"><img src="https://via.placeholder.com/150" /></div>
                  <div className="name">Sreca</div>
                </div>
                <p>Click on the add to cart button then checkout the product with additional information then select payment method and continue to the payment process for order.</p>
              </div>
            </div>
            <div className="question-card">
              <div className="question">
                <div className="profile-info">
                  <div className="image"><img src="https://via.placeholder.com/150" /></div>
                  <div className="name">Forhad Hossain</div>
                </div>
                <p>How to order something?</p>
              </div>
              <div className="reply">
                <div className="profile-info">
                  <div className="image"><img src="https://via.placeholder.com/150" /></div>
                  <div className="name">Sreca</div>
                </div>
                <p>Click on the add to cart button then checkout the product with additional information then select payment method and continue to the payment process for order.</p>
              </div>
            </div>
            <div className="question-card">
              <div className="question">
                <div className="profile-info">
                  <div className="image"><img src="https://via.placeholder.com/150" /></div>
                  <div className="name">Forhad Hossain</div>
                </div>
                <p>How to order something?</p>
              </div>
              <div className="reply">
                <div className="profile-info">
                  <div className="image"><img src="https://via.placeholder.com/150" /></div>
                  <div className="name">Sreca</div>
                </div>
                <p>Click on the add to cart button then checkout the product with additional information then select payment method and continue to the payment process for order.</p>
              </div>
            </div>
            <div className="question-card">
              <div className="question">
                <div className="profile-info">
                  <div className="image"><img src="https://via.placeholder.com/150" /></div>
                  <div className="name">Forhad Hossain</div>
                </div>
                <p>How to order something?</p>
              </div>
              <div className="reply">
                <div className="profile-info">
                  <div className="image"><img src="https://via.placeholder.com/150" /></div>
                  <div className="name">Sreca</div>
                </div>
                <p>Click on the add to cart button then checkout the product with additional information then select payment method and continue to the payment process for order.</p>
              </div>
            </div>
            <div className="question-card">
              <div className="question">
                <div className="profile-info">
                  <div className="image"><img src="https://via.placeholder.com/150" /></div>
                  <div className="name">Forhad Hossain</div>
                </div>
                <p>How to order something?</p>
              </div>
              <div className="reply">
                <div className="profile-info">
                  <div className="image"><img src="https://via.placeholder.com/150" /></div>
                  <div className="name">Sreca</div>
                </div>
                <p>Click on the add to cart button then checkout the product with additional information then select payment method and continue to the payment process for order.</p>
              </div>
            </div>
            <div className="question-card">
              <div className="question">
                <div className="profile-info">
                  <div className="image"><img src="https://via.placeholder.com/150" /></div>
                  <div className="name">Forhad Hossain</div>
                </div>
                <p>How to order something?</p>
              </div>
              <div className="reply">
                <div className="profile-info">
                  <div className="image"><img src="https://via.placeholder.com/150" /></div>
                  <div className="name">Sreca</div>
                </div>
                <p>Click on the add to cart button then checkout the product with additional information then select payment method and continue to the payment process for order.</p>
              </div>
            </div>
          </div>
          <button className="show-more">Show More</button>
        </div>
      </div>
    </div>
  )
}
